import {css} from 'lit';
export const styles = css`:host {
  --height: calc(var(--viewport-height) - var(--page-header-height));
  --header-height: 65px;
  --header-margin: 8px;
  --calendar-height: calc(100% - var(--header-height) - var(--header-margin));

  /* Full calendar */
  --fc-small-font-size: 0.85em;
  --fc-page-bg-color: #fff;
  --fc-neutral-bg-color: rgba(208, 208, 208, 0.3);
  --fc-neutral-text-color: #808080;
  --fc-border-color: #ddd;
  --fc-button-text-color: #fff;
  --fc-button-bg-color: var(--primary-500);
  --fc-button-border-color: var(--primary-500);
  --fc-button-hover-bg-color: var(--primary-600);
  --fc-button-hover-border-color: var(--primary-600);
  --fc-button-active-bg-color: var(--primary-700);
  --fc-button-active-border-color: var(--primary-700);
  --fc-event-bg-color: #dfe4f5;
  --fc-event-border-color: #dfe4f5;
  --fc-event-text-color: var(--text-primary);
  --fc-event-selected-overlay-color: rgba(0, 0, 0, 0.25);
  --fc-more-link-bg-color: #d0d0d0;
  --fc-more-link-text-color: inherit;
  --fc-event-resizer-thickness: 8px;
  --fc-event-resizer-dot-total-width: 8px;
  --fc-event-resizer-dot-border-width: 1px;
  --fc-non-business-color: rgba(215, 215, 215, 0.3);
  --fc-bg-event-color: rgb(143, 223, 130);
  --fc-bg-event-opacity: 0.3;
  --fc-highlight-color: rgba(188, 232, 241, 0.3);
  --fc-today-bg-color: rgba(255, 255, 0, 0.1);
  --fc-now-indicator-color: red;

  display: block;
  font-size: 12px;
}

  @media screen and (min-width: 992px) {:host {
    display: grid;
    grid-template-columns: 3fr 1fr;
    grid-gap: 16px
}
  }

  @media (min-width: 768px) {:host {
    --header-height: 30px;
    --height: calc(var(--viewport-height) - var(--page-header-height) - 64px);

    font-size: 16px
}
  }

.reservations {
  padding: 16px;
}

.reservations > ef-icon-block {
    margin-bottom: 16px;
    font-size: 18px;
  }

.calendar,
.details {
  background: var(--contrast-light);
  height: auto;
  height: var(--height, auto);
}

.calendar {
  padding: 16px 8px;
}

@media screen and (min-width: 768px) {

.calendar {
    padding: 16px
}
  }

.details {
  display: none;
  overflow: auto;
}

@media screen and (min-width: 992px) {

.details {
    display: block
}
  }

header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  height: var(--header-height);
  margin-bottom: var(--header-margin);
}

@media (hover: hover) {
      header .btn-v1:hover {
        --border-color: var(--primary-100);

        filter: none;
      }
    }

header .btn-v1.active {
      --background: var(--primary-100);
      --background-hover: var(--primary-100);
      --background-active: var(--primary-100);
      --border-color: transparent;
    }

@media screen and (max-width: 767px) {
      header .btn-v1 ef-icon-block {
        --font-size-primary: 12px;
      }
    }

header .title {
    color: var(--primary-700);
    font-size: 1em;
    margin: 0;
  }

@media screen and (max-width: 767px) {

header ef-grid-list[col='4'] {
      width: 100%;
      margin-top: 8px
  }
    }

header .nav ef-icon {
      margin: 0;
    }

header .nav .today {
      --font-size-base: 14px;
    }

ef-hero-2 [slot='title'] {
    font-size: 30px;
    font-weight: 600;
  }

ef-hero-2 [slot='short'] {
    font-size: 16px;
  }

ef-hero-2 [slot='title'] + [slot='short'] {
    margin-top: 16px;
  }
`;
export default styles;
